<template>
   
     <div >
           
           <div  class="g_headerDesktop g_desktopOn" >
                
                    <div style="float:right" v-if="isOnline">
                        <s-button @onclick="aideConcours=true" icon="question" afterIcon="video" label="" theme="is-info"/>
                    </div>
                    <s-modal
                        :open="aideConcours"
                        title="Vous voulez une aide sur :"
                        :close="true"
                        @close="aideConcours=false"
                    >
                        
                        <div style="margin-top:10px;" >
                            <s-you-tube id="video_formee"  theme="is-info" label="Mélée & formée" />
                        </div>
                        <div style="margin-top:10px;">
                            <s-you-tube id="video_tournante" theme="is-info" label="Mélée Tournante" />
                        </div>
                        <div style="margin-top:10px;">
                            <s-you-tube id="video_gg" theme="is-info" label="Gagnant Gagnant" />
                        </div>
                        <div style="margin-top:10px;">
                            <s-you-tube id="video_parPoules" theme="is-info" label="Par poules" />
                        </div>
                    </s-modal>
                    <div class="title is-4" style="padding-left: 20px" v-if="saison==null">
                        <s-l id="lit_tournoi_club_title" :v='club.name'>Les concours du club : %v</s-l>
                        <div style="width:100%" >
                            <s-button theme="is-primary" 
                                :label="filterTournois ? 'Concours archivés' : 'Concours en cours'" 
                                :icon="filterTournois ? 'database' : 'play'" 
                                @onclick="setFilter" 
                                v-show="saison==null"
                            />
                            &nbsp;
                            <s-button 
                                :theme="filterTournois ? 'is-success' : 'is-dark'" 
                                :label="filterTournois ? 'Créer un concours' :'Créer un concours passé'" icon="plus"
                                @onclick="add" :role="role"    
                                :disabled="isOffline"
                                v-show="saison==null"
                                v-if="$getRole()!='visiteur'"
                                :tuto="club"
                                id="createConcours"
                            />
                            
                        </div>
                    </div>
                    <div class="title is-4" style="padding-left: 20px" v-if="saison!=null">
                        <div>{{club.name}} :</div>
                            <s-l id="list_saison_club_title" :v="saison.nom">Saison : %v</s-l> 
                        <div style="float: right;margin-right: 10px;">
                            <s-button theme="is-success" 
                                        label="Classement" 
                                        icon="trophy" 
                                        @onclick="goClassement" 
                                    />&nbsp;&nbsp;
                            <s-button theme="is-warning" 
                                        label="Modifier la saison" 
                                        icon="edit" 
                                        @onclick="modifierSaison" 
                                        :role="role"
                                    />
                        </div>
                    </div>
                    
                
         </div>
           <div class="g_menuMobile" v-show="!open" >
            <table class="g_menuFooterMin">
                <tr>
                    <td colspan="5" class="g_headerFooter">
                        <span style="padding-left: 20px" v-if="saison==null">
                        <s-l id="tournoi_title">Les concours {{filterTournois ? 'en cours' : 'archivés' }}  </s-l>
                        </span>
                        <span style="padding-left: 20px" v-if="saison!=null">
                        <s-l id="tournoi_title">Concours de {{saison.nom}}  </s-l>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>
                        
                        <s-button theme="is-light" 
                            label="Mon club" 
                            icon="bookmark" 
                            @onclick="goClub()" 
                            mode="V"
                            v-if="!saison"
                        />
                
                
                        <s-button theme="is-light" 
                            label="Saisons" 
                            icon="film" 
                            @onclick="goSaisons()" 
                            v-if="saison"
                            mode="V"
                        />
                    
                    
                    </td>
                     <td>
                        <s-button theme="is-warning" 
                            label="Modifier" 
                            icon="edit" 
                            @onclick="modifierSaison" 
                            mode="V"
                            v-if="saison"
                            :role="role"
                        />
                    </td>
                    <td>
                         <div v-if="saison">
                            <s-button theme="is-light" 
                                label="Classement" 
                                icon="trophy" 
                                @onclick="goClassement" 
                                mode="V"
                            />
                         </div>
                    </td>
                     <td>
                        <s-button theme="is-light" 
                            :label="filterTournois ? 'Archives' : 'En cours'" 
                            :icon="filterTournois ? 'database' : 'play'" 
                            @onclick="setFilter" 
                            mode="V"
                        />
                    </td>
                     <td>
                        
                        <s-button 
                            label="Créer" 
                            icon="plus" 
                            :theme="filterTournois ? 'is-success' : 'is-dark'" 
                            @onclick="add"
                            mode="V"
                            id="createConcours"
                            v-if="$getRole()!='visiteur' && $getRole()!='player' && saison==null"
                        />

                         
                    </td>
                </tr>
            </table>
         </div>
          
            <div class="listTournois" v-if="tournois.length>0"  >
                <div v-for="tournoiItem in tournois" 
                    :class="tournoiItem.state=='FINISH' ? 'tournoi tournoiFinish' : ' tournoi'" 
                    v-show="showTournoi(tournoiItem)">
                
                    <list-item
                        :tournoi="tournoiItem"
                        :club="club"
                        @delete="openDeleteModalTournoi(tournoiItem)"
                        @start="startModalTournoi(tournoiItem)"
                        @open="openTournoi(tournoiItem)"
                        @edit="edit(tournoiItem)"
                        @openListSaison="openModalListSeason(tournoiItem)"
                        @detacherSaison="detacherSaison(tournoiItem)"
                        @dupliquer="dupliquer(tournoiItem)"
                        :role="role"
                        :saisons="saisons"
                    />
                    
                </div>
            </div>
            <div class="g_notItems" v-if="nbTournois==0">
                <span v-if="!filterTournois">
                <s-l id="tournoi_nothingArchive"> Aucun concours archivé pour le moment</s-l>
                </span>
                <span v-if="filterTournois">
                <s-l id="tournoi_nothing"> Aucun concours pour ce club pour le moment</s-l>
                </span>
            </div>
            
            <add-tournoi 
                :open="openModalTournoi" 
                :club="clubData" 
                @close="openModalTournoi=false" 
                :tournoi="tournoiDataInit"
                @saved="openTournoi"
                :saisonTournoi="saison"
                :saisons="saisons"
                @createSeason="createSeason"
                :dupliquer="dupliquerTournoi"
                :clotured="!filterTournois"
                v-if="clubData"
            />
           
           
           
            <s-confirm 
                title="Supprimer un tournoi"
                :open="deleteTournoiModal"
                @yes="deleteTournoi()"
                @no="deleteTournoiModal=false"
                >
                    <div v-if="tournoiSelected != null">
                        <s-l id="tournoi_delete" :v="formatDate(tournoiSelected.date) + ' à ' + tournoiSelected.heure">Etes vous sur de vouloir supprimer le tournoi planifié au %v</s-l>
                        
                    </div>
            </s-confirm>
            <s-modal
                :open="openListSeason"
                :close="true"
                @close="openListSeason=false"
                title="Liste des saisons"
            >
                <s-button icon="plus" label="Créer une nouvelle saison" theme="is-primary" @onclick="createSeason"/><br/><br/>
                Sélectionner la saison :
                <div v-for="saison in saisons" class="saisonSelect" v-on:click="inclureSaison(saison.id)" v-if="saison.state!='FINISH'">
                    {{saison.nom}} ( <i style="font-size:14px">{{saison.joueurs.length}} joueurs</i> )
                </div>
            </s-modal> 
             <s-modal-code
                :open="openConfirmCode"
                :club="clubData"
                @close="openConfirmCode=false"
                @valid="validCode"
            />
           <add-season 
                :open="openModalTournoisSaison" 
                :club="clubData" 
                @close="openModalTournoisSaison=false" 
                :tournoi="tournoiInit"
                :saison="saisonInit"
            />
            <s-modal
                :open="errorCreateClub"
                @close="errorCreateClub=false"
                :close="true"
            >
                <s-l id="errorCreateClub">Vous n'êtes pas le GESTIONNAIRE du club<br/>Il faut que le club possède un abonnement pour que vous puissiez créer un concours<br/>Veuillez contacter le GESTIONNAIRE du club pour qu'il crée votre concours. Une fois crée vous allez pourvoir organiser le concours</s-l>
            </s-modal>
            <waiting :open="modalStarting"/>
    </div>
                    
</template>
<style scoped>
   
    .notTournoi {
        font-size: 25px;
        padding: 10px;
        color: black;
    }
    .tournoi {
        display: inline-block;
        width: 100%;
        max-width: 500px;
        vertical-align: top;
        
      
        margin-bottom: 20px;
        height: 350px;
       
        background-color: rgba(255, 255, 255, 0.4);
        color: black;
    }
     .tournoiFinish {
       background-color: rgba(179, 179, 179, 0.4);
       
    }
    .saisonSelect {
        padding: 10px;
        border: thin solid var(--bluebg);
        color: black;
        margin-top: 10px;
        cursor: pointer;
        font-weight: bolder;
    }
    .saisonSelect:hover {
        background-color: antiquewhite;
    }
    @media screen and (min-width: 420px) {  
        .tournoi {
            margin-left: 10px;
        }
        .listTournois {
            padding-top: 80px;
            height: 100%;
            
        }
    }
    @media screen and (max-width: 420px) {  
        .tournoi {
            margin-left: 0px;
            
        }
        .listTournois {
            padding-top: 10px;
            height: 100%;
            width: 99%;
            margin-right: auto;
            margin-left: auto;
            margin-bottom: 100px;
        }
    }
</style>
<script>
import club_fct         from '@/firebase/club'
import ListItem     from '@/views/tournoi/list/listItem.vue'
import AddTournoi   from '@/views/tournoi/list/addTournoi.vue'
import AddSeason    from '@/views/season/addSeason.vue'
import firebase_api  from '@/firebase/firebase_api'
import tournoi_fct from "@/firebase/tournoi"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import saison_fct from "@/firebase/season.js"
export default {
    props: ["club","role","saison"],
    components: {
        ListItem,
        AddTournoi,
        navbarTournoi,
        AddSeason
    },
    watch: {
        saison() {
             this.refresh();
        },
        openModalTournoi(val) {
            if (val) {
               
                
                if (this.$getRole()!='owner' && this.club.id!="demo") {
                    if (this.$getRole()=='admin' && this.filterTournois==false)
                        this.openModalTournoi = true;
                    else {
                        if (typeof(this.club.subscription)!="undefined") {
                            if (this.club.subscription.status != "active")
                                this.openModalTournoi = false;
                        }
                        else
                            this.openModalTournoi = false;
                    }
                }
                if (this.openModalTournoi==false) 
                    this.errorCreateClub = true;
            }
        }
    },
    computed: {
        credit: {
            get() {
       
            if (this.$store.getters.getCredit == null)
              return 0;
            else
              return this.$store.getters.getCredit.credit
            }
        },
        open: {
            get() {
                return this.openModalTournoi || this.openListSeason;
            }
        },
        nbTournois: {
            get() {
                var nbTournois = 0;
                
                
                this.tournois.forEach(tournoi => {
                    if (this.saison==null) {
                        if (this.filterTournois)
                            var finish = tournoi.state == 'FINISH';
                        else
                            var finish = tournoi.state != 'FINISH';
                    }
                    else
                        var finish = false;
                    nbTournois = !finish ? nbTournois + 1 : nbTournois;
                });
               
                return nbTournois;
            }
        }
    },
    
    data() {
        return {
            errorCreateClub: false,
            dupliquerTournoi: false,
            openModalTournoi: false,
            openListSeason: false,
            openModalTournoisSaison: false,
            deleteTournoiModal:false,
            startTournoiModal: false,
            tournoiSelected: null,
            filterTournois: true,
            clubData: [],
            tournois: [],
            saisons: [],
            tournoiDataInit: JSON.parse(JSON.stringify(tournoi_fct.object.data)),
            isTournoi: false,
            modalStarting: false,
            saisonInit: JSON.parse(JSON.stringify(saison_fct.object.data)),
            tournoiInit: JSON.parse(JSON.stringify(saison_fct.object.tournoi)),
            aideConcours: false,
            openConfirmCode: false,
            verifyCode: false            
        }
    },
    mounted() {
      this.refresh();
      
    },
    /* firestore() {
        if (this.saison==null) {
            return {
                clubData: firebase_api.api.getDb().collection('club').doc(this.club.id),
                tournois: ,
                saisons: 
            }
        }
        else {
             return {
                clubData: firebase_api.api.getDb().collection('club').doc(this.club.id),
                tournois: firebase_api.api.getDb().collection('club').doc(this.club.id).collection("tournois")
                    .where("saison","==",this.saison.id).orderBy("date"),
                saisons: firebase_api.api.getDb().collection('club').doc(this.club.id).collection("saisons").where("state","==","INPROGRESS")
                
                    
            }
        }
    },*/
    methods: {
        refresh() {
           
            this.$bind("clubData", firebase_api.api.getDb().collection('club').doc(this.club.id)).then(()=>{
                if (this.clubData.id=="demo") {
                    this.openModalTournoi = true;
                }
            });
            if (this.saison!=null)
                    this.$bind("tournois", firebase_api.api.getDb().collection('club').doc(this.club.id).collection("tournois")
                            .where("saison","==",this.saison.id).orderBy("date", "desc"))
            else
                    this.$bind("tournois", firebase_api.api.getDb().collection('club').doc(this.club.id).collection("tournois")
                            .orderBy("date", "desc"))
            this.$bind("saisons", firebase_api.api.getDb().collection('club').doc(this.club.id).collection("saisons"))   
        },
        validCode() {
            this.verifyCode = true;
            this.goClassement();
        },
        dupliquer(tournoi) {
            this.dupliquerTournoi = true;
            this.tournoiDataInit = JSON.parse(JSON.stringify(tournoi));
            this.openModalTournoi = true;
        },
        edit (tournoi) {
            this.dupliquerTournoi = false;
            this.tournoiDataInit = JSON.parse(JSON.stringify(tournoi));
            this.openModalTournoi = true;
        },
        goClassement() {
            
            if (this.$getRole()!="visiteur" || this.verifyCode) {
                this.openConfirmCode = false;
                this.verifyCode=false;
                this.$router.push({name: "classementSeason" , params: {id: this.club.id, idSeason: this.saison.id}});
            }
            else {
                this.verifyCode=false;
                this.openConfirmCode = true;
            }
        },
        showTournoi(tournoi) {
                if (this.saison==null) {
                    var bool = this.filterTournois && tournoi.state!='FINISH' ;
                    if (!bool) 
                        bool = (tournoi.state=='FINISH' && !this.filterTournois)
                
                    if (bool)
                        this.isTournoi = true;
                    return bool;
                }
                else return true;
        
            
        },
        modifierSaison() {
            this.openModalTournoisSaison=true;
            this.saisonInit = this.saison;
            this.tournoiInit = JSON.parse(JSON.stringify(saison_fct.object.tournoi))
        },
        setFilter() {
            this.filterTournois = !this.filterTournois;
             this.isTournoi = false;
        },
         openDeleteModalTournoi(tournoi) {
            
            this.tournoiSelected = tournoi;
            this.deleteTournoiModal = true;
        },
        startModalTournoi(tournoi) {
            
            this.tournoiSelected = tournoi;
            this.startTournoiModal = true;
        },
        openTournoi(tournoi) {
            this.tournoiSelected = tournoi;
            this.$emit("openInscription", tournoi);
        },
        deleteTournoi() {
            tournoi_fct.object.delete(this.club, this.tournoiSelected.id, ()=>{
                this.deleteTournoiModal = false;
            });
        },
         formatDate(date) {
            return this.$dateToYYYYMMDD(new Date(date))
        },
        startTournoi() {
            tournoi_fct.object.setState(this.club, this.tournoiSelected, "INSCRIPTION", ()=>{
                this.startTournoiModal = false;
            })
        },
         add() {
            this.tournoiDataInit = JSON.parse(JSON.stringify(tournoi_fct.object.data));
            this.dupliquerTournoi = false;
            this.openModalTournoi = true;
        },
        close() {
             this.$router.push({name: "club" });
        },
        goClub() {
             this.$router.push({name: "viewClub", params: {id: this.club.id}});
        },
        goSaisons() {
             this.$router.push({name: "saison", params: {id: this.club.id}});
        },
        async inclureSaison(idSeason) {
           
            
            if (idSeason!=-1) {
                this.tournoiSelected.saison = idSeason;
                tournoi_fct.object.affectJoueursSaison (this.club, this.tournoiSelected, ()=>{
                   
                });
               
                tournoi_fct.object.addJoueursBySeason(this.club, this.tournoiSelected);
            }
            else {
            await tournoi_fct.object.deaffectJoueursSaison (this.club, this.tournoiSelected, ()=>{
                    delete this.tournoiSelected.saison
                });
            
            }
            tournoi_fct.object.set(this.club,this.tournoiSelected, ()=>{
                this.openListSeason = false;
                
            })
            
        },
        detacherSaison(tournoi) {
            this.tournoiSelected = tournoi;

            this.inclureSaison (-1);
        },
        openModalListSeason(tournoi) {
            this.tournoiSelected = tournoi;
            this.openListSeason = true;
        },
        createSeason() {
            this.openModalTournoisSaison = true;
            this.saisonInit=JSON.parse(JSON.stringify(saison_fct.object.data));
        }
    }
}
</script>